export function renderAuthorshipValueActorTemplate({
  userAccessor
}: {
  userAccessor: string
}): string {
  return `const actor = row.original.${userAccessor}
      const label = actor?.name || actor?.email`
}
